import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { mergeData } from './utils';
/**
 * @todo Propagate more options to children.
 */
export var SpaceFlex = function SpaceFlex() {
  return function (options) {
    var children = options.children;
    if (!Array.isArray(children)) return [];
    var _options$direction = options.direction,
      direction = _options$direction === void 0 ? 'row' : _options$direction,
      _options$ratio = options.ratio,
      ratio = _options$ratio === void 0 ? children.map(function () {
        return 1;
      }) : _options$ratio,
      _options$padding = options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding,
      flexData = options.data;
    var _ref = direction === 'col' ? ['y', 'height', 'width', 'x'] : ['x', 'width', 'height', 'y'],
      _ref2 = _slicedToArray(_ref, 4),
      mainStart = _ref2[0],
      mainSize = _ref2[1],
      crossSize = _ref2[2],
      crossStart = _ref2[3];
    var sum = ratio.reduce(function (total, value) {
      return total + value;
    });
    var totalSize = options[mainSize] - padding * (children.length - 1);
    var sizes = ratio.map(function (value) {
      return totalSize * (value / sum);
    });
    var newChildren = [];
    var next = options[mainStart] || 0;
    for (var i = 0; i < sizes.length; i += 1) {
      var _a = children[i],
        data = _a.data,
        rest = __rest(_a, ["data"]);
      var newData = mergeData(data, flexData);
      newChildren.push(Object.assign(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, mainStart, next), mainSize, sizes[i]), crossStart, options[crossStart] || 0), crossSize, options[crossSize]), "data", newData), rest));
      next += sizes[i] + padding;
    }
    return newChildren;
  };
};
SpaceFlex.props = {};